import moment from "moment";
import {
  // ... existing imports ...
  CREATE_NEW_RIDE,
  FETCH_RIDES,
  CREATE_NEW_PICKDROP,
  FETCH_PICKDROP,
  UPDATE_STATUS_RESERVE,
  UPDATE_STATUS_PICKDROP,
  SET_ASSIGNMENT_STATUS,
  SET_ACTIVE_DRIVER,
  UPDATE_RIDES,
  SET_TIME,
  SET_FLEET_RESERVE_TAB_INDEX,
  UPDATE_DRIVER_PICKDROP,
  UPDATE_DRIVER_RESERVE,
  OPTIMIZE_RESERVATIONS,
  APPLY_OPTIMIZE_RESERVATIONS,
  FLEET_GET_CUSTOMER_LIST
} from "../actions/fleetReserve.action";

const initialState = {
  // ... existing state properties ...
  rides: [],
  pickdrop: [],
  assignmentStatus: true, // Added for storing the list of rides
  activeDriver:false,
  time: {
      from: moment(new Date()),
      to: moment(new Date()),
      interval: "Today",
    },
    selectedTabIndex: 0,
    customerList: [],
};

const FleetReserveReducer = (state = initialState, action) => {
  switch (action.type) {
    // ... existing cases ...

    case FETCH_RIDES:
      return { ...state, rides: action.value };

    case CREATE_NEW_RIDE:
      return {
        ...state,
        rides: [...state.rides, action.value],
      };
    case CREATE_NEW_PICKDROP:
      return {
        ...state,
        pickdrop: [...state.pickdrop, action.value],
      };
    case FETCH_PICKDROP:
      return { ...state, pickdrop: action.value };
    case UPDATE_STATUS_RESERVE:
      return { ...state, rides: action.value };
    case UPDATE_STATUS_PICKDROP:
      return { ...state, pickdrop: action.value };
    case SET_ASSIGNMENT_STATUS:
      return {
        ...state,
        assignmentStatus: action.value,
      };
      case SET_TIME:
            return { ...state, time: action.value };
      case SET_ACTIVE_DRIVER:
      return {
        ...state,
        activeDriver: action.value,
      };
      case UPDATE_RIDES:
      return {
        ...state,
        rides: action.value,
      };
      case SET_FLEET_RESERVE_TAB_INDEX:
      return {
        ...state,
        selectedTabIndex: action.value,
      };
      case UPDATE_DRIVER_PICKDROP:
      return {
        ...state,
        pickdrop: action.value,
      };
      case UPDATE_DRIVER_RESERVE:
      return {
        ...state,
        rides: action.value,
      };
      case OPTIMIZE_RESERVATIONS:
      return {
        ...state,
        rides: action.value,
      };
      case APPLY_OPTIMIZE_RESERVATIONS:
      return {
        ...state,
        rides: action.value,
      };
      case FLEET_GET_CUSTOMER_LIST:
      return { ...state, customerList: action.value };

    default:
      return state;
  }
};

export default FleetReserveReducer;
